<template>
    <div>
        <form id="form-element" v-on:submit.prevent="validateBeforeSubmitObservations">
            <h4>Observaciones</h4>
            <ejs-grid ref='grid'
                      :dataSource='gridDataComplianceObservations'
                      :allowPaging="true"
                      :allowSorting="true"
                      :pageSettings='pageSettings'
                      :allowTextWrap='true'>
                <e-columns>
                    <e-column field="responsable" :headerText="$t('gridHeaderText.user')" width="120px"
                              textAlign="center" :template="templateResponsable"></e-column>
                    <e-column field="created_at" :headerText="$t('gridHeaderText.date')" width="170px"
                              textAlign="center"></e-column>
                    <e-column field="observacion" width="100%" :headerText="$t('gridHeaderText.observations')"
                              textAlign="left"></e-column>
                    <e-column :headerText="$t('gridHeaderText.support')" textAlign="center" width="150px"
                              :template="templateComplianceSupport"></e-column>
                </e-columns>
            </ejs-grid>
            <div class="row">
                <div class="col-12">
                    <hr class="mt-4 mb-4">
                </div>
            </div>
            <div class="form-group">
                <ejs-datepicker name="observations_date" data-msg-containerid="formObservationsError1"
                                v-model="formDataObservations.observations_date" :format="'yyyy-MM-dd'"
                                :placeholder="'Fecha:'"></ejs-datepicker>
                <div id="formObservationsError1"></div>
            </div>
            <div class="form-group">
                <ejs-textbox name="observations_text" :multiline="true" data-msg-containerid="formObservationsError2"
                             v-model="formDataObservations.observations_text" placeholder="Observación"></ejs-textbox>
                <div id="formObservationsError2"></div>
            </div>
            <div class="form-group">
                <label for="uploadFileObservationse">Documento</label>
                <ejs-uploader ref="uploadObjObservationse" name="uploadFiles" id="uploadFilesObservations"
                              :multiple='false' :asyncSettings="uploaderSettings" :uploading="addHeaders"
                              :removing="addHeaders" :success="beforeUploadFilesObservations"></ejs-uploader>
            </div>
            <ejs-button type='submit' cssClass="e-primary mt-3">Guardar</ejs-button>
        </form>
    </div>
</template>

<script>
import axios from 'axios'
import {Page, Sort} from "@syncfusion/ej2-vue-grids";

export default {
    name: "processes-detail-process-task-observations-updates",
    props: ["data"],
    provide: {
        grid: [Sort, Page]
    },
    data() {
        return {
            formDataObservations: {
                statusComplianceId: 0,
                observations_date: '',
                observations_text: '',
                pathFile: ''
            },
            optionsObservations: {
                rules: {
                    'observations_text': {
                        required: [true, "* Campo observación requerido."]
                    },
                    'observations_date': {
                        required: [true, "* Campo fecha requerido."],
                        date: [true, "* Campo fecha no valido."]
                    },
                }
            },
            uploaderSettings: {
                saveUrl: process.env.BASE_URL_FILE_SAVE,
                removeUrl: process.env.BASE_URL_FILE_REMOVE
            },
            templateResponsable: function (e) {
                return {
                    template: Vue.component('componentResponsable', {
                        template: `
                            <ejs-tooltip :content="data.responsable" ref="tooltip" :position="'TopCenter'">
                            <div class="e-avatar e-avatar-small e-avatar-circle">{{ $getInitials(data.responsable) }}
                            </div>
                            </ejs-tooltip>`,
                        data() {
                            return {
                                data: {},
                            };
                        },
                    })
                }
            },
            templateComplianceSupport: function (e) {
                return {
                    template: Vue.component('componentComplianceSupport', {
                        template: `
                            <div v-html="viewLinksSupport(data)"></div>`,
                        data() {
                            return {
                                data: {},
                            };
                        },
                        methods: {
                            viewLinksSupport: function (data) {

                                var response = "";

                                if (!!data.soporte) {
                                    var extArr = data.soporte.split('.');
                                    var ext = extArr[extArr.length - 1].toLowerCase();
                                    var show = true;
                                    var classDoc = '';

                                    if (ext === 'pdf') {
                                        classDoc = "e-pdf-icon";
                                    } else if (ext === 'jpg' || ext === 'png' || ext === 'jpeg' || ext === 'bmp') {
                                        classDoc = "e-image-icon";
                                    } else {
                                        show = false;
                                    }
                                    var splitImage = data.soporte.split(/[\\$]/).pop();
                                    response += "<a class='mx-1 " + classDoc + "' href='" + process.env.BASE_URL_API_BACK + "viewFile/" + splitImage + "' target='_blank'></a>";
                                    response += "<a class='mx-1 e-download-icon' href='" + process.env.BASE_URL_API_BACK + "downloadFile/" + extArr[0] + "/" + extArr[1] + "' target='_self' download></a>";
                                }

                                if (response == "") {
                                    response += "-";
                                }

                                return response;
                            }
                        }
                    })
                }
            },
            gridDataComplianceObservations: [],
            pageSettings: {pageSize: 5}
        }
    },
    mounted: function () {
        this.formObjObservations = new FormValidator('#form-element', this.optionsObservations);
    },
    methods: {
        addHeaders: function (args) {
            args.currentRequest.setRequestHeader('Authorization', `Bearer ${this.$store.state.moduleSession.token}`);
        },
        beforeUploadFilesObservations: function (args) {
            var obj = JSON.parse(args.e.srcElement.response);
            this.formDataObservations.pathFile = obj.path;
        },
        initProcessTaskObservationsUpdates: function () {
            this.formDataObservations.statusComplianceId = this.data.est_id;
            axios.post('/auth/processes/getComplianceObservationsDetail', {
                complianceStatusId: this.data.est_id,
            }).then(response => {
                this.gridDataComplianceObservations = response.data;
            });
        },
        validateBeforeSubmitObservations: function () {
            let formStatus = this.formObjObservations.validate();
            if (formStatus) {
                axios.post('/auth/processes/setComplianceObservations', {
                    data: this.formDataObservations,
                }).then(response => {
                    this.formObjObservations.element.reset();
                    Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                    axios.post('/auth/processes/getComplianceObservationsDetail', {
                        complianceStatusId: this.data.est_id,
                    }).then(response => {
                        this.gridDataComplianceObservations = response.data;
                    });
                });
            }
        }
    },
    created: function () {
        this.initProcessTaskObservationsUpdates();
    }
}
</script>
